export default __webpack_public_path__ + "static/media/about-picture-1.fb128aab.jpg";